/* eslint-disable no-shadow */
const state = {
	orderProducts: [],
	totalOrderData: {},
	amountToPay: 0
}

const getters = {
	getOrderProducts: state => state.orderProducts,
	getTotalOrderData: state => state.totalOrderData,
	getAmountToPay: state => state.amountToPay
}

const mutations = {
	setOrderProductsMutation: (state, payload) => {
		state.orderProducts = payload
	},
	setTotalOrderDataMutation: (state, payload) => {
		state.totalOrderData = payload
	}
}

const actions = {
	setOrderProducts: ({ commit }, payload) => {
		commit('setOrderProductsMutation', payload)
	},
	setTotalOrderData: ({ commit }, payload) => {
		commit('setTotalOrderDataMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
